import Image from 'next/image'
import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { styled, Typography } from '@mui/material'

import { ourStoryData } from '../mocks/ourStory/data'

export const OurStoryCraft: React.FC = () => {
  const { title, paragraphs, imagePath } = ourStoryData.craft

  return (
    <StyledSection>
      <StyledTitle variant="h2">
        {title}
      </StyledTitle>
      <StyledGrid>
        <StyledImageContainer>
          <StyledImageWrapper>
            <Image
              src={imagePath}
              alt="Artist sketching characters by hand"
              fill
              style={{ objectFit: 'cover', borderRadius: pxToRem(16) }}
            />
          </StyledImageWrapper>
        </StyledImageContainer>
        <StyledTextContent>
          {paragraphs.map((paragraph, index) => (
            <StyledParagraph key={index} variant="body1">
              {paragraph}
            </StyledParagraph>
          ))}
        </StyledTextContent>
      </StyledGrid>
    </StyledSection>
  )
}

const StyledSection = styled('div')({
})

const StyledTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 600,
  fontSize: pxToRem(28),
  color: theme.palette.primary.main,
  marginBottom: pxToRem(32),

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(36),
    marginBottom: pxToRem(40),
  },
}))

const StyledGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(4),
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(6),
  },
}))

const StyledImageContainer = styled('div')(({ theme }) => ({
  borderRadius: pxToRem(16),
  overflow: 'hidden',

  [theme.breakpoints.up('md')]: {
    order: 1,
  },
}))

const StyledImageWrapper = styled('div')({
  position: 'relative',
  width: '100%',
  aspectRatio: '4/3',
})

const StyledTextContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: pxToRem(20),
})

const StyledParagraph = styled(Typography)(({ theme }) => ({
  fontSize: pxToRem(16),
  lineHeight: 1.8,
  color: theme.palette.primary.main,

  [theme.breakpoints.up('md')]: {
    fontSize: pxToRem(18),
  },
}))
